import { render } from "./ReportPanelComponent.vue?vue&type=template&id=8a2440dc&scoped=true"
import script from "./ReportPanelComponent.vue?vue&type=script&lang=js"
export * from "./ReportPanelComponent.vue?vue&type=script&lang=js"

import "./ReportPanelComponent.vue?vue&type=style&index=0&id=8a2440dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a2440dc"]])

export default __exports__